import React, { FC } from 'react';

import { usePriceCustomizer } from '../PriceCustomizerContext';
import { PaymentPlanOption } from './PaymentPlanOption';
import { PaymentConceptName, PlanComparisonProps } from './types';
import styles from './styles.module.css';

const installmentConceptsSequence: Array<PaymentConceptName | null> = [
  'downpayment',
  'installment',
  'total',
];

const inFullConceptsSequence: Array<PaymentConceptName | null> = [
  'downpayment',
  null, // Null entries create visual spacing
  'total',
];

export const PlanComparison: FC<PlanComparisonProps> = ({
  isLoading,
  onPlanSelect,
}) => {
  const {
    selectFrequency,
    frequency,
    paymentPlanOptions,
  } = usePriceCustomizer();

  return (
    <div className={styles.planComparison}>
      {paymentPlanOptions.map(plan => {
        return (
          <div key={plan.name} className={styles.planListItem}>
            <PaymentPlanOption
              plan={plan}
              selected={plan.name === frequency}
              loading={isLoading}
              breakdownSequence={
                plan.name === 'fullPay'
                  ? inFullConceptsSequence
                  : installmentConceptsSequence
              }
              onSelect={() => {
                onPlanSelect(plan.name);
                selectFrequency(plan.name);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
